import AboutSectionComponent from "./AboutComponent";

const AboutSection = ({ id }: any) => {
  return <AboutSectionComponent id={id} />;
};

export default AboutSection;
